enum ActionTypes {
  LOAD_CSV_DEVICES_WITH_SAMPLEPOINTS_LIST_REQUEST = 'LOAD_CSV_DEVICES_WITH_SAMPLEPOINTS_LIST_REQUEST',
  LOAD_CSV_DEVICES_WITH_SAMPLEPOINTS_LIST_SUCCESS = 'LOAD_CSV_DEVICES_WITH_SAMPLEPOINTS_LIST_SUCCESS',
  LOAD_CSV_DEVICES_WITH_SAMPLEPOINTS_LIST_FAILURE = 'LOAD_CSV_DEVICES_WITH_SAMPLEPOINTS_LIST_FAILURE'
}

export default ActionTypes;
